/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AverageDaysWorkedPerFreelancerFamilyResponse
 */
export interface AverageDaysWorkedPerFreelancerFamilyResponse {
    /**
     * 
     * @type {string}
     * @memberof AverageDaysWorkedPerFreelancerFamilyResponse
     */
    family: string;
    /**
     * 
     * @type {number}
     * @memberof AverageDaysWorkedPerFreelancerFamilyResponse
     */
    averageDaysWorked: number;
}

/**
 * Check if a given object implements the AverageDaysWorkedPerFreelancerFamilyResponse interface.
 */
export function instanceOfAverageDaysWorkedPerFreelancerFamilyResponse(value: object): value is AverageDaysWorkedPerFreelancerFamilyResponse {
    if (!('family' in value) || value['family'] === undefined) return false;
    if (!('averageDaysWorked' in value) || value['averageDaysWorked'] === undefined) return false;
    return true;
}

export function AverageDaysWorkedPerFreelancerFamilyResponseFromJSON(json: any): AverageDaysWorkedPerFreelancerFamilyResponse {
    return AverageDaysWorkedPerFreelancerFamilyResponseFromJSONTyped(json, false);
}

export function AverageDaysWorkedPerFreelancerFamilyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AverageDaysWorkedPerFreelancerFamilyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'family': json['family'],
        'averageDaysWorked': json['averageDaysWorked'],
    };
}

export function AverageDaysWorkedPerFreelancerFamilyResponseToJSON(value?: AverageDaysWorkedPerFreelancerFamilyResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'family': value['family'],
        'averageDaysWorked': value['averageDaysWorked'],
    };
}

